import { render, staticRenderFns } from "./homeHeader.vue?vue&type=template&id=87852aec&scoped=true"
import script from "./homeHeader.vue?vue&type=script&lang=js"
export * from "./homeHeader.vue?vue&type=script&lang=js"
import style0 from "./homeHeader.vue?vue&type=style&index=0&id=87852aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87852aec",
  null
  
)

export default component.exports